import { merge } from 'lodash';

export function lineAreaStyle(op) {
  return merge(
    {
      title: {
        left: 10,
        top: 10,
        textStyle: {
          color: '#00A0E9',
          fontSize: 24
        }
      },
      grid: {
        containLabel: true,
        left: 30,
        right: 30,
        bottom: 20
      },
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'time',
        axisLine: {
          lineStyle: {
            color: '#00A0E9'
          }
        },
        splitLine: { show: false }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#00A0E9'
          }
        },
        splitLine: { show: false },
        max(v) {
          if (v.max < 0) {
            return v.max / 2;
          }
          if (v.max == 0) {
            return v.max + 0.0001;
          }
          return v.max < 100 ? 2 * v.max : v.max + 100;
        }
      },
      series: [
        {
          type: 'line',
          symbolSize: 10,
          smooth: true,
          data: []
        }
      ]
    },
    op
  );
}
